const Ls15DisfrutarTiempo = () => {
    return (
        <div className="container-fluid bg--main ps-0 ps-sm-0 ps-md-0 ps-lg-3">
            <div className="row d-flex p-0">
                <div className="col-sm-12 col-md-8 col-lg-7 col-xl-6">
                    <h1 className='titulo--lesson--color--1'>Disfrute al m&aacute;ximo el tiempo con su beb&eacute;; <span className="titulo--lesson--color--2">ll&eacute;nelo de amor y cari&ntilde;o</span></h1>

                    <h1 className="text--subtitulo p-4">Todos queremos ver a nuestro beb&eacute; sano y feliz</h1>

                    <div className='container ps-4'>
                        <p className='texto--parrafo'>A continuaci&oacute;n, damos algunas recomendaciones para que ayude al desarrollo de su beb&eacute;:</p>
                    </div>

                    <div className='col d-block d-sm-block d-md-none style--gif-2 background--baby'>
                        <img src="./img/Ls15Baby.gif" className='img--gid-2' />
                        {/* ./img/Ls1Background.png */}
                    </div>

                    <div className="container px-4">
                        <div className="bg-white rounded py-3 pe-2 m-0">
                            <div className="row d-flex align-items-center">
                                <div className="col-2">
                                    <img src="./img/Ls15Nota.png" className='icon-lesson15 ps-lg-3' />
                                </div>
                                <div className="col-10">
                                    <p className='texto--parrafo m-0'>H&aacute;blele, l&eacute;ale cuentos y c&aacute;ntele frecuentemente para estimular de desarrollo del lenguaje.</p>
                                </div>
                            </div>

                            <div className="row d-flex align-items-center pt-2">
                                <div className="col-2">
                                    <img src="./img/Ls15Star.png" className='icon-lesson15  ps-lg-3' />
                                </div>
                                <div className="col-10">
                                    <p className='texto--parrafo m-0'>Mu&eacute;strele objetos brillantes cerca de su cara para estimular la visi&oacute;n.</p>
                                </div>
                            </div>

                            <div className="row d-flex align-items-center pt-2">
                                <div className="col-2">
                                    <img src="./img/Ls15Micro.png" className='icon-lesson15 ps-lg-3' />
                                </div>
                                <div className="col-10">
                                    <p className='texto--parrafo m-0'>Mueva suavemente un sonajero para estimular su sentido de la audici&oacute;n.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='container'>
                        <div className='row d-flex ps-4 pt-4'>
                            <div className='col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex style--burbuja py-2 align-items-center'>
                                <div className='col-3 col-ms-3 col-md-2 col-lg-1 col-xl-1'>
                                    <img src="./img/Ls15Heart.png" className='' />
                                </div>
                                <div className='col-9 col-ms-9 col-md-9 col-lg-9 col-xl-11'>
                                    <p className='texto--burbuja lh-1 ps-lg-3 ps-xl-5 m-0'>Los mejores momentos son los que se comparten en familia, adem&aacute;s de ser un apoyo incondicional.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="col-md-4 d-none d-sm-block d-sm-none d-md-block">
                    <img src="./img/Ls15Baby.gif" className='justify-content-start pt-5 style--image-baby-10' />
                </div>
            </div>
        </div>
    )
}

export default Ls15DisfrutarTiempo;